<template>
  <v-form ref="formRef" class="product-public-style" validate-on="blur">
    <div>
      <p class="fb-650 fs-18">{{ details.nameEn }}</p>
      <p
        class="fs-14"
        :style="{
          color: primaryColor
        }"
      >
        {{ details.code }}
      </p>
    </div>
    <!-- 规格颜色 -->
    <div class="color mt-0" v-if="specsColor.colors?.length">
      <p class="title fs-14 mt-1 mb-2 py-2 pl-2">
        PRODUCT COLOR: {{ specsColor.colors[colorIndex].color }}
      </p>
      <ul class="mt-2 w-100" style="margin-left: -8px">
        <li
          v-for="(item, i) in specsColor.colors"
          :key="i"
          class="ml-2 mb-2 d-inline-block"
        >
          <v-tooltip
            :text="item.color"
            location="bottom"
            class="custom-tooltip"
            :open-on-click="true"
          >
            <template v-slot:activator="{ props }">
              <div class="img-wrap" :class="{ active: colorIndex === i }">
                <img
                  v-if="item.imageUrl"
                  v-bind="props"
                  @click="selectColor(i)"
                  :src="item.imageUrl + '?x-oss-process=image/resize,l_300'"
                />
              </div>
            </template>
          </v-tooltip>
        </li>
      </ul>
    </div>

    <!-- 印刷方式-->
    <p class="title fs-14 mt-1 mb-1 pl-2 py-2">IMPRINT METHOD & QUANTITY</p>
    <div>
      <v-chip-group
        v-model="form.productWay"
        mandatory
        selected-class="text-primary fb-650"
        @update:modelValue="changeImprints"
        color="rgba(255, 0, 0, 0.5)"
      >
        <v-chip
          class="mr-4"
          :value="tag.printingWayNameEn"
          v-for="(tag, i) in imprints"
          :key="i"
          variant="outlined"
          rounded="sm"
          >{{ tag.nameEn }}</v-chip
        >
      </v-chip-group>
    </div>

    <!-- 数量阶梯 -->
    <v-row no-gutters class="price mt-2 fs-14">
      <div
        v-if="form.productWay != 'Sample' && productPricingSteps.length"
        class="d-flex w-100"
      >
        <div
          :class="[
            'column',
            'fc-666',
            store?.userInfo?.status == 1 ? '' : 'w120'
          ]"
        >
          <p>Quantity</p>
          <p v-if="store?.userInfo?.status == 1">Price Each</p>
          <p v-else>Price Each&nbsp;({{ productPricingSteps.length }}C)</p>
        </div>
        <div class="ladder scroller d-flex pb-1">
          <div v-for="(item, i) in productPricingSteps" :key="i" class="column">
            <p :class="i === ladderIndex ? 'ladderActive' : ''" class="pl-2">
              {{ item.num }} +
            </p>
            <p
              :class="i === ladderIndex ? 'ladderActive' : ''"
              class="fb-650 pl-2"
            >
              $ {{ item.price }}
            </p>
          </div>
        </div>
      </div>
      <div v-else>
        <div class="d-flex simple" v-if="specsSize.hasSize">
          <div class="column fc-666">
            <span class="pl-2">Price Each</span>
          </div>
          <div class="ladderActive">
            <span class="px-2" v-if="store?.userInfo?.status == 1"
              >${{ details.proofingFee }}</span
            >
            <span class="px-2" v-else>${{ details.proofingFee }}&nbsp;(C)</span>
          </div>
        </div>
      </div>
    </v-row>

    <!-- 输入数量 -->
    <v-row no-gutters class="mt-1 py-1 pl-2 product-size fs-14 mb-4">
      <p class="w-100 pl-2 fs-14 fb-650">Enter the quantity you'd like</p>
      <ul
        v-if="specsSize.hasSize && specsSize.sizes.length"
        class="d-flex flex-wrap"
      >
        <li
          v-for="(item, i) in specsSize.sizes"
          :key="i"
          class="pl-2 pr-2 mt-2"
        >
          <input
            @keydown.enter.prevent
            v-model.trim="item.num"
            @blur="writeNumber(i, item)"
            @input="onInput(i, item)"
            placeholder="0"
          />
          {{ item.size }}
        </li>
      </ul>
      <div v-else class="d-flex no-size fs-14 mt-4 ml-2 pl-2">
        <input
          @keydown.enter.prevent
          v-model="specsSize.num"
          @blur="writeNumber"
          @input="onInput(0, specsSize)"
          class="mb-2"
          placeholder="0"
        />
        <span class="pa-2" v-if="store?.userInfo?.status == 1">
          × $
          {{
            form.productWay === "Sample"
              ? details.proofingFee
              : productPricingSteps?.[ladderIndex]?.price ||
                productPricingSteps?.[0]?.price ||
                0
          }}
          ea
        </span>
        <span class="pa-2" v-else>
          × $
          {{
            form.productWay === "Sample"
              ? details.proofingFee
              : productPricingSteps?.[ladderIndex]?.price ||
                productPricingSteps?.[0]?.price ||
                0
          }}
          &nbsp;(C)&nbsp;ea
        </span>
      </div>
    </v-row>

    <!-- 印刷位 -->
    <div
      class="imprint-location"
      v-if="!hasBlankOrSample && form.productWay && imprintLocations?.length"
    >
      <p class="title fs-14 my-2 py-2 pl-2 mt-0">
        IMPRINT LOCATION(S) & OPTION
      </p>
      <v-row no-gutters>
        <v-col cols="12" xs="12" sm="2" md="2" lg="3" xl="2" class="label fs-14"
          >Imprint Location</v-col
        >
        <v-col cols="12" xs="12" sm="10" md="10" lg="9" xl="10">
          <v-row no-gutters class="mb-2">
            <v-col :cols="4" v-for="(item, i) in imprintLocations" :key="i">
              <v-checkbox
                v-model.trim="form.imprintLocation"
                class="mr-2"
                :value="item"
                hide-details
                @click.native="burying('imprintLocation')"
              >
                <template #label>
                  <span class="fc-black-09">
                    {{
                      productUtil.getImprintLocationName(
                        item,
                        imprintLocationsCount
                      )
                    }}
                  </span>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- 印刷针数或其他  -->
      <v-row
        no-gutters
        v-if="
          !hasImprintColor && !hasBlankOrSample && pricingMethodDict?.length > 1
        "
      >
        <v-col
          cols="12"
          xs="12"
          sm="2"
          md="2"
          lg="3"
          xl="2"
          class="label fs-14"
          >{{ hasStiches ? "Stiches" : "Imprint Option" }}</v-col
        >
        <v-col cols="12" xs="12" sm="10" md="10" lg="9" xl="10">
          <div class="d-flex ml-1">
            <v-select
              placeholder="Select Stiches"
              v-model="form.pricingMethod"
              :items="pricingMethodDict"
              hide-details
              :clearable="false"
              @click.native="burying('stiches')"
            ></v-select>
          </div>
        </v-col>
      </v-row>

      <!-- 印刷颜色 -->
      <v-row
        no-gutters
        v-if="
          hasImprintColor &&
          !hasBlankOrSample &&
          !specImprints.includes(form.productWay)
        "
      >
        <v-col cols="12" xs="12" sm="2" lg="3" xl="2" class="label fs-14"
          >Imprint Color</v-col
        >
        <v-col cols="12" xs="12" sm="10" lg="9" xl="10">
          <v-row no-gutters>
            <!-- 选择几色印刷 -->
            <v-col cols="12" md="3">
              <v-select
                class="auto-select multi-color"
                v-model="form.pricingMethod"
                :items="pricingMethodDict"
                hide-details
                :clearable="false"
                placeholder="Select Multi-color"
              ></v-select>
            </v-col>

            <!-- 选择印刷颜色 -->
            <v-col cols="12" md="9" class="pl-4">
              <v-select
                v-if="form.pricingMethod.toLowerCase() != 'full-color'"
                class="auto-select"
                v-model="form.imprintColor"
                multiple
                :items="imprintColorOptions"
                item-title="label"
                item-value="label"
                hide-details
                @update:model-value="updateImprintColor"
                :clearable="false"
                placeholder="Select Imprint Color"
              >
                <template v-slot:selection="{ item }">
                  <v-chip
                    size="small"
                    class="mr-1"
                    label
                    style="padding: 0 0 0 2px"
                  >
                    <div
                      class="imprint-color-selected rounded-sm"
                      :style="setImprintColor(item.raw)"
                    ></div>
                    <span class="fs-12 mx-1">{{ item.title }}</span>
                    <v-icon
                      class="pointer"
                      @click="removeImprintColor(item.title)"
                      icon="mdi-close"
                      size="16"
                    />
                  </v-chip>
                </template>
                <template v-slot:item="{ props, item }">
                  <v-list-item v-bind="props">
                    <template v-slot:prepend>
                      <div
                        class="imprint-color mr-4 rounded-sm"
                        style="z-index: 1"
                        :style="setImprintColor(item.raw)"
                      ></div>
                    </template>
                  </v-list-item>
                </template>
              </v-select>
              <div
                class="allowed-demo"
                v-if="form.imprintColor.length > imprintColorNum"
              >
                You selected {{ imprintColorNum }}-Color. Only
                {{ imprintColorNum }} Color(s) Allowed.
              </div>
            </v-col>
          </v-row>

          <!-- 手动添加印刷颜色 -->
          <v-row no-gutters class="w-100 mt-5 d-flex">
            <v-text-field
              v-model="otherImprintColor"
              placeholder="Enter your preferred color besides the colors listed above."
              variant="outlined"
              hide-details
            ></v-text-field>
            <v-btn
              @click="addImprintColor"
              color="primary"
              flat
              class="ml-4"
              size="x-small"
              height="36"
              :disabled="!otherImprintColor"
            >
              <span class="fs-14">+ Add</span>
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <!-- 是否包含样品 -->
      <v-row no-gutters class="mt-2">
        <v-col cols="12" xs="12" sm="2" md="2" lg="3" xl="2" class="label fs-14"
          >Physical Sample</v-col
        >
        <v-col cols="12" xs="12" sm="10" md="10" lg="9" xl="10">
          <div class="d-inline-flex">
            <v-checkbox
              v-model="form.sampleFlag"
              class="mr-2"
              hide-details
              @click.native="burying('sample')"
            >
              <template #label>
                <span class="fc-black-09">Send me a physical sample</span>
              </template>
            </v-checkbox>
            <div class="d-inline-block mt-2">
              <shopmall-physical-sample-tip></shopmall-physical-sample-tip>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <v-row class="mt-0 w-100" v-show="!calcFreightZipCodeBol">
      <v-col
        cols="12"
        xs="12"
        sm="2"
        md="2"
        lg="3"
        xl="2"
        class="label fs-14 d-flex algin-center"
        style="color: #666"
      >
        <div class="d-flex align-end" style="height: 22px">
          <span> ZIP Code</span>
          <shopmall-tip :size="22" color="#999" icon="mdi-help-circle-outline">
            <span>
              Please enter a ZIP code for a continental US address. For shipping
              rates to other places, please contact our sales team at
              <a :href="`mailto:${infoMailbox}`" target="_blank">{{
                infoMailbox
              }}</a>
            </span>
          </shopmall-tip>
        </div>
      </v-col>
      <v-col
        cols="12"
        xs="12"
        sm="10"
        md="10"
        lg="9"
        xl="10"
        class="pt-0 pl-0 pr-0"
      >
        <div class="d-flex align-center pl-4">
          <v-text-field
            v-model.trim="form.postCode"
            class="flex-grow-1 flex-shrink-1"
            style="color: #666"
            :rules="[
              (value) => {
                if (!value) {
                  return zipcodeBol ? zipcodeBol : 'Zip Code is required'
                } else {
                  const regex = /^(?:\d{5}|\d{5}-\d{4})$/
                  if (!regex.test(value)) {
                    return 'Must be a valid Zip Code'
                  } else {
                    const pattern = /^(006|007|008|009|967|968|995|996|997|998)/
                    if (pattern.test(value) && value != 96799) {
                      return 'Please enter a ZIP code for continental US.'
                    }

                    const militaryPattern = /^(969|09[0-9]|96[2-6]|340|96799)/
                    if (militaryPattern.test(value)) {
                      return 'WARNING! This ZIP code includes military addresses.'
                    }
                  }
                }
                return true
              }
            ]"
            :clearable="true"
            placeholder="Enter ZIP Code for shipping estimate."
            @blur="() => setPostCodeFn('blur')"
          ></v-text-field>
          <v-checkbox
            v-model="form.residential"
            class="flex-grow-0 flex-shrink-0 ml-2"
            @update:modelValue="() => setPostCodeFn('checkbox')"
            @click.native="burying('residential')"
          >
            <template #label>
              <span class="fc-black-09">Residential Address</span>
            </template>
          </v-checkbox>
        </div>
      </v-col>
    </v-row>

    <!-- 支付 ipad pc -->
    <div class="d-none d-sm-block">
      <v-row no-gutters class="pay mt-0">
        <v-col cols="6">
          <div class="left mr-2 py-2 d-flex align-center">
            <div class="w-100 text-center">
              <v-icon
                icon="mdi-truck-cargo-container"
                size="32"
                :color="primaryColor"
              ></v-icon>
              <p class="fc-black-09">
                Estimated Delivery Date is
                <span v-if="deliveryInfo.tbdFlag === 1">TBD</span>
                <span v-else>
                  <span
                    v-if="
                      deliveryInfo.estimatedDelivery &&
                      deliveryInfo.endEstimatedDelivery
                    "
                  >
                    {{
                      $Utils.timeFormat(deliveryInfo.estimatedDelivery) +
                      " - " +
                      $Utils.timeFormat(deliveryInfo.endEstimatedDelivery)
                    }}
                  </span>
                  <span v-else>{{
                    $Utils.timeFormat(deliveryInfo.estimatedDelivery)
                  }}</span>
                </span>
              </p>
              <div
                class="text-center fs-14 fc-666 py-3"
                v-if="deliveryInfo.tbdFlag === 1"
              >
                <p>
                  We'll be reaching out to you shortly to verify the delivery
                  schedule for your order.
                </p>
                <p>Thank you for your understanding and support.</p>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="6">
          <v-row no-gutters style="position: relative">
            <product-price
              :price-info="priceInfo"
              :has-blank-or-sample="hasBlankOrSample"
              :sample-flag="form.sampleFlag"
              :has-shipping-tips="true"
              :loaddingStatus="loaddingStatus"
              :show-zip-code-hint="showZipCodeHint"
              discount-tip
              show-discount
            ></product-price>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters class="mt-4 d-flex justify-end">
        <div
          class="d-none pb-3 d-md-flex flex-row-reverse justify-space-between position-relative"
          :style="{
            height:
              platForm === 'RP' &&
              store?.accessToken &&
              !hasBlankOrSample &&
              showDesignNowBol
                ? '100px'
                : 'unset'
          }"
        >
          <v-btn flat color="primary" @click="toCart">Add to Cart</v-btn>
          <v-btn
            v-if="!hasBlankOrSample && showDesignNowBol"
            flat
            color="blue"
            class="mr-4"
            variant="outlined"
            @click="design"
            >Upload Your Design</v-btn
          >
          <v-btn
            v-if="platForm === 'RP' && store?.accessToken"
            flat
            color="blue"
            class="mr-4"
            variant="outlined"
            @click="shareProduct"
            >Share Product</v-btn
          >
          <v-btn
            flat
            color="blue"
            class="mr-4"
            :class="{
              'download-flyer':
                !hasBlankOrSample &&
                showDesignNowBol &&
                platForm === 'RP' &&
                store?.accessToken
            }"
            variant="outlined"
            @click="downloadFlyer"
            >Download Flyer</v-btn
          >
        </div>
      </v-row>
    </div>

    <!-- 支付 phone -->
    <div class="d-block d-md-none pay-phone pa-2">
      <v-row no-gutters>
        <v-col cols="8" class="fs-12" @click="drawer = !drawer">
          <div style="min-height: 28px">
            <p v-if="!loaddingStatus">
              <span class="fs-18 price"
                >$ {{ priceInfo.discountTotalPrice }}</span
              >
              <v-icon
                class="mdi mdi-help-circle-outline ml-1 mb-1"
                size="16"
              ></v-icon>
            </p>
            <shopmall-text-loading wid="60px" v-else />
          </div>
          <p class="fc-black-09">
            Estimated Delivery Date is
            <span v-if="deliveryInfo.tbdFlag === 1">TBD</span>
            <span v-else>
              <span
                v-if="
                  deliveryInfo.estimatedDelivery &&
                  deliveryInfo.endEstimatedDelivery
                "
              >
                {{
                  $Utils.timeFormat(deliveryInfo.estimatedDelivery) +
                  " - " +
                  $Utils.timeFormat(deliveryInfo.endEstimatedDelivery)
                }}
              </span>
              <span v-else>{{
                $Utils.timeFormat(deliveryInfo.estimatedDelivery)
              }}</span>
            </span>
          </p>
          <div class="text-left fs-12" v-if="deliveryInfo.tbdFlag === 1">
            <p>
              We'll be reaching out to you shortly to verify the delivery
              schedule for your order.
            </p>
            <p>Thank you for your understanding and support.</p>
          </div>
        </v-col>
        <v-col cols="4" class="d-flex align-center justify-end">
          <v-btn-group divided class="py-2">
            <!-- <v-btn variant="outlined" size="small">Design</v-btn> -->
            <v-btn @click="toCart" color="primary" class="pr-2" size="small"
              >Add to Cart</v-btn
            >
          </v-btn-group>
        </v-col>
      </v-row>
    </div>

    <!-- 底部抽屉信息 -->
    <div class="drawer w-100" v-if="drawer">
      <v-row no-gutters class="title">
        <v-col cols="6" class="pl-2">
          <p>Details</p>
        </v-col>
        <v-col cols="6" class="text-right pr-2">
          <v-icon
            class="mdi mdi-close"
            size="18"
            @click="drawer = false"
          ></v-icon>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12">
          <product-price
            :price-info="priceInfo"
            :has-blank-or-sample="hasBlankOrSample"
            :sample-flag="form.sampleFlag"
            :has-shipping-tips="true"
            :loaddingStatus="loaddingStatus"
            :show-zip-code-hint="showZipCodeHint"
            discount-tip
            show-discount
          ></product-price>
        </v-col>
      </v-row>
    </div>

    <!-- 添加购物车抽屉 -->
    <shopmall-drawer-cart ref="drawerCart"></shopmall-drawer-cart>

    <!-- 发送邮件 -->
    <ShareProduct
      v-model="shareProductDialog"
      :details="details"
    ></ShareProduct>

    <!-- 遮罩 -->
    <div class="mask" v-if="drawer"></div>
  </v-form>
</template>

<script setup>
const { $multiPlatform } = useNuxtApp();
const primaryColor = $multiPlatform.primaryColor
const infoMailbox = $multiPlatform.infoMailbox;
const platForm = $multiPlatform.mall
import Dicts from "./dict/index"
import ShareProduct from "./share-product.vue"
import { productInteractor, systemInteractor } from "~/core"
import { useProductStore, useDesignStore, useUserStore } from "~/stores"
import { trackAddCart } from "~/utils/report/tracking"
import { getAddCartTrackParam } from '~/utils'
const store = useUserStore()
const {
  $Bus,
  $Utils,
  $Message,
  $Buryingpoint,
  $BaseClickBurying,
  $MallPageName,
  $ClickSource,
  $Reporter
} = useNuxtApp()
const productUtil = useProduct()
const imprintColorOptions = Dicts.imprintColors
const props = defineProps({
  details: {
    type: Object,
    default: {}
  },
  specsColor: {
    type: Object,
    default: {}
  },
  specsSize: {
    type: [Object, Array],
    default: {}
  },
  imprints: {
    type: Object,
    default: {}
  },
  minNum: {
    type: [Number, String],
    default: 0
  },
  dieDrawingImgs: {
    type: Array,
    default: () => {
      return []
    }
  }
})
const emit = defineEmits(["productQuantityExceedsFn"])
const loaddingStatus = ref(true) //价格计算loading状态
const formRef = ref(null)
const colorIndex = ref(0)
const drawer = ref(false)
const ladderIndex = ref(null)
const hasBlankOrSample = ref(false) // 印刷方式是否是Blank或者Sample
const hasImprintColor = ref(false) // 是否存在印刷颜色
const hasStiches = ref(false) // 是否是刺绣针数
const imprintLocations = ref([]) // 印刷位字典
const imprintLocationsCount = ref({})
const pricingMethodDict = ref([]) // 字典项
const deliveryInfo = ref({}) // 送达时间
const priceInfo = ref({}) // 产品价格
const otherImprintColor = ref("") // 添加非字典印刷色
const productPricingSteps = ref([]) // 数量阶梯
const specImprints = ref(["Debossed", "Cameo Printing", "Laser Engraved"]) // 凹印（Debossed）、凸印（Cameo Printing）、激光雕刻（Laser Engraved）不需要选择印刷颜色
const productStore = useProductStore() // 虚拟效果图
const designStore = useDesignStore()
const drawerCart = ref(null)
const postCodeEx = ref(false)
const zipcodeBol = ref(true)
const oldPostCode = ref(store?.zipCodeInfo?.postCode ?? "")
const shareProductDialog = ref(false)
const imprintColorNum = computed(() => {
  let num = form.value.pricingMethod
  if (num) {
    num = num.split("-")[0]
  } else {
    num = 0
  }
  return num
})
const showDesignNowBol = computed(() => {
  return props?.details?.productPrintingSwitch ?? false
}) //是否显示DesignNow按钮
// 是否显示刀模图按钮
const showDownloadBtn = computed(() => {
  if (props.dieDrawingImgs.length) {
    return true
  } else {
    return false
  }
})

// zipCode和是否居住地址改变的时候
const setPostCodeFn = async (type) => {
  if (type === "blur") {
    zipcodeBol.value = true
    const { valid } =  formRef.value && (await formRef.value.validate(["postCode"]))
    if (!valid) return
    if (form.value.postCode != oldPostCode.value) {
      calculatePrice(true)
    }
    oldPostCode.value = form.value.postCode
  } else {
    calculatePrice(true)
  }
}

// 表单
let form = ref({
  productWay: "", // 印刷方式
  productWayId: "", // 印刷方式id
  imprintLocation: [], // 印刷位
  imprintColor: [], // 印刷色
  pricingMethod: undefined, // 计价方式
  printingConditions: "", // 印刷条件
  sampleFlag: false, // 是否包含样品

  postCode: store?.zipCodeInfo?.postCode ?? "", //postCode
  residential: store?.zipCodeInfo?.residential ?? false //是否居住地址
})

const calcFreightZipCodeBol = computed(() => {
  if (
    props?.details?.calcFreight &&
    form.value?.productWay !== "Sample" &&
    !form.value?.sampleFlag
  ) {
    return true
  } else {
    return false
  }
})

const showZipCodeHint = computed(() => {
  if (calcFreightZipCodeBol.value) {
    return false
  } else {
    return !form.value.postCode
  }
})
// 限制输入的数量
const onInput = (index, item) => {
  if (!item?.num) return
  item.num = item.num.toString().replace(/[^\d]/g, "")
  if (item.num.length > 8) {
    item.num = item.num.slice(0, 8)
  }
}
/**
 * 选择产品颜色
 * @param {i} 颜色索引
 */
const selectColor = (i) => {
  colorIndex.value = i

  calculatePrice()
  $Bus.emit("spec-image", props.specsColor.colors[i].imageUrl)
}

/**
 * 选择印刷方式
 * @param {val} 印刷方式
 */
const changeImprints = (val) => {
  form.value.productWay = val
  hasBlankOrSample.value = ["Blank", "Sample"].includes(val)
  defaultPriceQuantity()

  // 选择非Black or Sample, 清空印刷色、计价方式、印刷条件
  if (!hasBlankOrSample.value) {
    form.value.imprintColor = []
    form.value.printingConditions = ""
  } else {
    form.value.productWayId = ""
    form.value.sampleFlag = false
  }
  form.value.imprintLocation = []
  form.value.pricingMethod = undefined
  // 选择Blank,重置印刷阶梯
  if (val === "Blank") {
    productPricingSteps.value = props.details.productPricingSteps
  }
  // 选择Sample，清空产品数量和阶梯高亮
  if (val === "Sample") {
    ladderIndex.value = null
    if (
      props.specsSize?.sizes?.length &&
      Array.isArray(props.specsSize.sizes)
    ) {
      props.specsSize.sizes = props.specsSize.sizes.map((item) => {
        return {
          ...item,
          num: ""
        }
      })
      props.specsSize.sizes[0].num = 1
    } else {
      props.specsSize.num = 1
    }
  }

  // 判断是否需要选择印刷颜色
  const ways = props.details.printingWays

  if (ways?.length) {
    for (let i = 0; i < ways.length; i++) {
      if (ways[i]?.printingWayNameEn === val) {
        form.value.productWayId = ways[i].printingWayId
        form.value.printingConditions = ways[i].printingConditions
        pricingMethodDict.value = ways[i].pricingMethod?.split(",")
        imprintLocations.value = ways[i].printingPositions?.split(",")
        imprintLocationsCount.value = productUtil.getImprintLocationsCount(
          imprintLocations.value || []
        )
        productPricingSteps.value = productUtil.getPriceSteps(
          ways[i].productPrintingWayPrices,
          props.details.priceScale
        )
        // 自动带入第一个印刷位
        if (!form.value.imprintLocation.length) {
          form.value.imprintLocation = [imprintLocations.value[0]]
        }
        // 设置计价方式
        if (pricingMethodDict.value?.length) {
          form.value.pricingMethod = pricingMethodDict.value[0]
        }
        break
      }
    }
  }

  if (form.value.printingConditions === "印刷颜色") {
    hasImprintColor.value = true
    hasStiches.value = false
    // 当计价方式只有一条且值为full-color隐藏选择颜色下拉框
    if (
      pricingMethodDict.value.length === 1 &&
      form.value.pricingMethod &&
      form.value.pricingMethod.toLowerCase() === "full-color"
    ) {
      hasImprintColor.value = false
    }
  } else if (form.value.printingConditions?.includes("刺绣")) {
    hasImprintColor.value = false
    hasStiches.value = true
  } else {
    hasImprintColor.value = false
    hasStiches.value = false
  }
}

/**
 * 获取规格数量
 * @returns 规格数量总和
 */
const getSpecNumber = () => {
  if (props.specsSize?.sizes?.length) {
    return $Utils.sum(props.specsSize.sizes, "num")
  } else {
    return props.specsSize.num
  }
}

/**
 * 输入产品数量
 */
const writeNumber = (i, item) => {
  const sum = getSpecNumber()
  if (form.value.productWay === "Sample") {
    if (sum > 1) {
      if (
        props.specsSize?.sizes?.length &&
        Array.isArray(props.specsSize.sizes)
      ) {
        props.specsSize.sizes = props.specsSize.sizes.map((item) => {
          return {
            ...item,
            num: ""
          }
        })
        props.specsSize.sizes[i].num = 1
      } else {
        props.specsSize.num = 1
      }
    }
  } else {
    if (productPricingSteps.value.length) {
      for (let i = productPricingSteps.value.length - 1; i >= 0; i--) {
        if (sum >= productPricingSteps.value[i].num) {
          ladderIndex.value = i
          break
        } else {
          ladderIndex.value = null
        }
      }
    }
  }
  calculatePrice(item)
  setTimeout(() => {
    const el = document.getElementsByClassName("ladderActive")
    if (el?.length && typeof el[0]?.scrollIntoViewIfNeeded === "function") {
      el[0].scrollIntoViewIfNeeded()
    }
  }, 200)
}

/**
 * 选择印刷颜色
 * @description form.pricingMethod-支持几色印刷
 */

const updateImprintColor = () => {
  let num = form.value.pricingMethod
  if (num) {
    num = num.split("-")[0]
    if (form.value.imprintColor.length > num) {
      if (num == 1) {
        form.value.imprintColor.splice(0, 1)
      } else {
        form.value.imprintColor.splice(num, 1)
        return $Message.warning(
          `You selected ${num}-Color. Only ${num} Color(s) Allowed.`
        )
      }
    }
  }
}

/**
 * 添加其它的印刷色
 */
const addImprintColor = () => {
  form.value.imprintColor.push(otherImprintColor.value)
  otherImprintColor.value = ""

  updateImprintColor()
}

/**
 * 删除印刷色
 * @param {color}
 */
const removeImprintColor = (color) => {
  const colors = form.value.imprintColor

  colors.find((item, i) => item === color && colors.splice(i, 1))
}

/**
 * 设置印刷颜色
 * @param {raw}
 */
const setImprintColor = (raw) => {
  if (raw.label) {
    if (raw.label === "White") {
      return `background: ${raw.value};border: 1px solid #ddd`
    } else {
      return `background: ${raw.value}`
    }
  } else {
    return `background-image: radial-gradient(circle at 10% 20%, rgb(222, 168, 248) 0%, rgb(168, 222, 248) 21.8%, rgb(189, 250, 205) 35.6%, rgb(243, 250, 189) 52.9%, rgb(250, 227, 189) 66.8%, rgb(248, 172, 172) 90%, rgb(254, 211, 252) 99.7%);`
  }
}

/**
 * 请求产品价格参数处理
 * @param {productId} 产品id
 * @param {imprintColor} 印刷颜色
 * @param {imprintLocation} 印刷位
 * @param {pricingMethod} 计价方式（当印刷条件不为‘印刷颜色’时，传值）
 * @param {printingConditions} 印刷条件
 * @param {productWay} 印刷方式
 * @param {productWayId} 印刷方式(blank和Sample可以不传，其他必传)
 * @param {sampleFlag} 是否发送样品（1：是；0否）
 * @param {specsType1} 规格类型1(颜色)
 * @param {specsValue1} 规格1
 * @param {productSpecsDTOList} 规格2
 */
const handlePriceParams = () => {
  const sizes = props.specsSize.sizes || []
  const paramForm = JSON.parse(JSON.stringify(form.value))
  const { postCode, residential } = form.value
  delete paramForm.postCode
  delete paramForm.residential
  const params = {
    ...paramForm,
    shipToAddress: {
      postCode,
      residential,
      country: "US"
    },
    sampleToAddress: {
      residential,
      postCode,
      country: "US"
    },
    productId: props.details.id,
    sampleFlag: form.value.sampleFlag ? 1 : 0,
    specsType1: props.specsColor.colors?.length
      ? props.specsColor.specsType
      : "",
    specsValue1: props.specsColor.colors?.length
      ? props.specsColor.colors[colorIndex.value].color
      : "",
    productSpecsDTOList: sizes.length
      ? sizes
          .filter((item) => item.num > 0)
          .map((item) => {
            return {
              productQuantity: item.num,
              specsValue: item.size,
              specsType: props.specsSize.specsType
            }
          })
      : [
          {
            productQuantity: props.specsSize.num,
            specsValue: "",
            specsType: ""
          }
        ]
  }

  return params
}

/**
 * 购物车参数处理
 */
const route = useRoute()
const handleCartParams = () => {
  // 处理印刷方式类型
  function handlePrintingType() {
    const type = form.value.productWay
    if (type === "Blank") {
      return 1
    } else if (type === "Sample") {
      return 2
    } else {
      return 0
    }
  }

  // 处理印刷位置
  function handleImprintLocation() {
    const imprintLocation = form.value.imprintLocation
    let locations = []

    if (imprintLocation.length > 0) {
      for (let i = 0; i < imprintLocation.length; i++) {
        locations.push({
          extend: "", // 扩展字段信息
          location: imprintLocation[i], // 印刷位置
          locationFiles: [] // 文件列表
        })
      }
    }

    return locations
  }

  // 产品规格
  const productSpecs = props.specsSize.hasSize
    ? props.specsSize.sizes
        .filter((item) => item.num > 0)
        .map((item) => {
          return {
            quantity: item.num,
            specsValue: item.size,
            specsType: props.specsSize.specsType
          }
        })
    : []

  // 产品印刷
  const productPrinting = {
    pricingMethod: form.value.pricingMethod, // 计价方式
    printingColors: form.value.imprintColor.join(","), // 印刷颜色
    printingWay: form.value.productWay, // 印刷方式
    printingWayId: form.value.productWayId, // 印刷方式ID
    printingWayType: handlePrintingType(), // 印刷方式类型(0:Print,1:Blank,2:Sample)
    printingLocations: handleImprintLocation(), // 印刷位置
    printingSurfaces: [], // 印刷面
    showPricingMethodFlag: 0
  }
  if (
    (!hasImprintColor.value &&
      !hasBlankOrSample.value &&
      pricingMethodDict.value?.length > 1) ||
    (hasImprintColor.value &&
      !hasBlankOrSample.value &&
      !specImprints.value.includes(form.productWay))
  ) {
    productPrinting.showPricingMethodFlag = 1
  }
  // 兼容老埋点 后面会删掉
  $Buryingpoint.addCart(route.query, props.details)
  
  const opts = trackAddCart(props.details)
  const params = {
    productId: props.details.id, // 产品ID
    productPicUrl:
      props.specsColor.colors?.[colorIndex.value]?.imageUrl ||
      props.details.imgMainUrl, // 产品图片地址
    quantity: getSpecNumber(), // 购买数量
    sampleFlag: form.value.sampleFlag ? 1 : 0, // 是否发送样品(0:不发送,1:发送)
    specsType: props.specsColor.colors?.length
      ? props.specsColor.specsType
      : "", // 规格类型
    specsValue: props.specsColor.colors?.length
      ? props.specsColor.colors[colorIndex.value].color
      : "", // 规格数据
    productSpecs: productSpecs, // 产品规格
    productPrinting: productPrinting, // 产品印刷
    // 添加购物车来源
    optSources:
      opts instanceof Array
        ? opts.map((item) => {
            return {
              optSource: item,
              ext: JSON.stringify({
                sourceParam: getAddCartTrackParam(item)
              })
            }
          })
        : [{ optSource: opts }]
  }

  return params
}

/**
 * 计算送达时间和产品价格
 */
const calculatePrice = $Utils.debounce(async (bol = false) => {
  if (formRef.value) {
    zipcodeBol.value = true
    const { valid } = await formRef.value.validate(["postCode"])
    if (!valid) return
  }
  const params = handlePriceParams()
  if (params?.productWay !== "Sample") {
    let total = params.productSpecsDTOList.reduce(
      (previousValue, currentValue, array) => {
        return previousValue + Number(currentValue.productQuantity)
      },
      0
    )
    if (total < productPricingSteps.value?.[0]?.num) {
      priceInfo.value = {
        busId: null,
        overBoxLimit: true,
        physicalSample: null,
        physicalSampleVOList: null,
        productPrice: null,
        productQuantity: null,
        setUpCharge: null,
        shippingCharge: null,
        totalPrice: null,
        discountTotalPrice: null,
        discountAmount: null
      }
      deliveryInfo.value = {
        tbdFlag: 0,
        estimatedDelivery: "",
        endEstimatedDelivery: ""
      }
      return
    }
  }
  if (params.productWay) {
    // 送达时间
    loaddingStatus.value = true
    const [timeRes] = await productInteractor.alculateProductDeliveryApi(params)
    timeRes && (deliveryInfo.value = timeRes)
    // 产品价格
    const [priceRes] =
      await productInteractor.alculateProductPriceAndMatchDiscountApi(params)
    if (priceRes) {
      if (bol) {
        if (priceRes.postCodeEx) {
          $Message.warning(
            "Freight calculation error. Please check the ZIP code you entered."
          )
          postCodeEx.value = true
        } else {
          let info = {
            postCode: form.value?.postCode ?? "",
            residential: form.value?.residential ?? false
          }
          store.setZipCodeInfo(info)
          postCodeEx.value = false
        }
      }
      if (!priceRes.overBoxLimit) {
        priceInfo.value = priceRes
      } else {
        priceInfo.value = {
          busId: null,
          overBoxLimit: true,
          physicalSample: null,
          physicalSampleVOList: null,
          productPrice: null,
          productQuantity: null,
          setUpCharge: null,
          shippingCharge: null,
          totalPrice: null,
          discountTotalPrice: null,
          discountAmount: null
        }
        emit("productQuantityExceedsFn")
      }
    }
    loaddingStatus.value = false
  }
}, 500)

/**
 * 设计效果图和添加购物车规格校验
 * @returns 是否通过校验
 */
const checkRules = () => {
  if (
    specImprints.value.includes(form.value.productWay) &&
    !form.value.pricingMethod
  ) {
    $Message.warning("Multi-color is required")
    return false
  }
  if (!form.value.productWay) {
    $Message.warning("Imprint method is required")
    return false
  }
  if (!hasBlankOrSample.value) {
    if (form.value.imprintLocation.length === 0) {
      $Message.warning("Imprint Location is required")
      return false
    }
    if (hasImprintColor.value) {
      if (
        !specImprints.value.includes(form.value.productWay) &&
        form.value?.pricingMethod.toLowerCase() != "full-color"
      ) {
        if (form.value.imprintColor.length === 0) {
          $Message.warning("Imprint Color is required")
          return false
        }
        const num = form.value.pricingMethod.split("-")[0]
        if (form.value.pricingMethod && form.value.imprintColor.length != num) {
          $Message.warning(
            `You selected ${num}-Color. Only ${num} Color(s) Allowed.`
          )
          return false
        }
      }
    } else {
      if (!form.value.pricingMethod && pricingMethodDict.value?.length > 1) {
        $Message.warning(
          `${hasStiches ? "Stiches" : "Imprint Option"} is required`
        )
        return false
      }
    }
  }

  // 印刷方式是非Sample，校验数量不能小于数量阶梯区间最小值
  if (form.value.productWay != "Sample") {
    const sum = getSpecNumber()
    // 产品数量不能为0
    if (sum < 1) {
      $Message.warning("Please enter quantity")
      return false
    }
    if (productPricingSteps.value.length) {
      const min = productPricingSteps.value[0].num

      if (sum < min) {
        $Message.warning(`Quantity at least ${min}`)
        return false
      }
    }
  }

  return true
}

/**
 * 下载传单
 */
const downloadFlyer = () => {
  $BaseClickBurying(
    $MallPageName?.mallProductDetail,
    $ClickSource?.mallDownloadFlyer
  )
  $Reporter.click({event: 'e_download_flyer'})
  const { code } = productStore.product
  window.open(`/flyer/${code}`, "_blank")
}

/**
 * 分享产品
 */
const shareProduct = () => {
  systemInteractor.eventRecordApi({eventName: "share_product"});
  $BaseClickBurying(
    $MallPageName?.mallProductDetail,
    $ClickSource?.mallShareProduct
  )
  $Reporter.click({event: 'e_share_product'})
  shareProductDialog.value = true
}

/**
 * 设计效果图
 */
const router = useRouter()
const design = async () => {
  if (formRef.value) {
    zipcodeBol.value = calcFreightZipCodeBol.value
    const { valid } = await formRef.value.validate(["postCode"])
    if (!valid) return
  }
  if (checkRules()) {
    if (priceInfo.value.overBoxLimit) {
      emit("productQuantityExceedsFn")
      return
    }
    const sum = getSpecNumber()
    const cartInfo = handleCartParams(sum)
    const priceParams = handlePriceParams()

    designStore.setCartInfo(cartInfo)
    designStore.setCalculatePriceParams(priceParams)
    designStore.setFromPageName("product-detail")
    const { nameEn, code } = productStore.product
    const params = {
      path: `/artwork-design/${code}-${$Utils.replaceSpacesWithDash(nameEn)}`
    }
    let routerData = router.resolve(params)
    $Utils.jumpNewPage(routerData.href, false)
    try {
      // 上传设计图点击事件埋点
      $BaseClickBurying(
        $MallPageName.mallOrderDetail,
        $ClickSource.mallProductDetailUploadDesign
      )
      $Reporter.click({event: 'e_product_detail_upload_design'})
    } catch (err) {}
  }
}

/**
 * 添加购物车
 */
const toCart = async () => {
  if (formRef.value) {
    zipcodeBol.value = calcFreightZipCodeBol.value
    const { valid } = await formRef.value.validate(["postCode"])
    if (!valid) return
  }
  if (postCodeEx.value && !calcFreightZipCodeBol.value) {
    $Message.warning(
      "Freight calculation error. Please check the ZIP code you entered."
    )
    return
  }
  // 下架的产品给出提示
  if (props.details.shelfStatus === 1) {
    $Message.warning("This item is no longer available.")
    return false
  }

  if (checkRules()) {
    const params = handleCartParams()
    params.productPrintingSwitch =
      props?.details?.productPrintingSwitch ?? false
    const [res, err] = await productInteractor.cartAddApi(params)
    if (res) {
      const cart = useCart()
      cart.initCartData(false)
      drawerCart.value.show(props.details.id)
      // 加购成功事件埋点
      try {
        $BaseClickBurying(
          $MallPageName?.mallProductDetail,
          $ClickSource?.mallProductDetailAddCartSuccess
        )
      } catch (err) {
        console.log(err)
      }
    } else if (!res && err === "OVER_BOX_LIMIT") {
      emit("productQuantityExceedsFn")
    }
  }
}

// 回显最小的价格阶梯
const defaultPriceQuantity = () => {
  if (ladderIndex.value > 0) {
    return false
  }
  if (form.value.productWay === "Sample") {
    return false
  }
  if (props.specsSize?.sizes?.length) {
    props.specsSize.sizes[0].num = props.minNum
  } else {
    props.specsSize.num = props.minNum
  }
  ladderIndex.value = 0
}

const burying = (type) => {
  if (type === "imprintLocation") {
    $BaseClickBurying(
      $MallPageName?.mallProductDetail,
      $ClickSource?.mallProductDetailPrintLoction
    )
    $Reporter.click({event: 'e_product_detail_print_loction'})
  } else if (type === "stiches") {
    $BaseClickBurying(
      $MallPageName?.mallProductDetail,
      $ClickSource?.mallProductDetailPrintStiches
    )
    $Reporter.click({event: 'e_product_detail_print_stiches'})
  } else if (type === "sample") {
    $BaseClickBurying(
      $MallPageName?.mallProductDetail,
      $ClickSource?.mallProductDetailSendSample
    )
    $Reporter.click({event: 'e_product_detail_send_sample'})
  } else if (type === "residential") {
    $BaseClickBurying(
      $MallPageName?.mallProductDetail,
      $ClickSource?.mallProductDetailResidentialAddress
    )
    $Reporter.click({event: 'e_product_detail_residential_address'})
  }
}

// 监听最小的价格阶梯
watch(
  () => props.minNum,
  (val) => {
    if (val > 0) {
      defaultPriceQuantity()
    }
  }
)

// 监听印刷方式,默认取第一个
watch(
  () => props.imprints,
  (imprints) => {
    form.value.productWay = imprints?.[0]?.printingWayNameEn ?? ""
    form.value.productWayId = imprints?.[0]?.printingWayId ?? ""

    changeImprints(form.value.productWay)
  }
)
// 监听价格计算参数
watch(
  () => [
    form.value.productWayId,
    form.value.imprintLocation,
    form.value.pricingMethod,
    form.value.sampleFlag,
    form.value.printingConditions
  ],
  () => {
    calculatePrice()
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.product-public-style {
  .title {
    background: #f5f5f5;
    font-weight: 650;
  }

  .color {
    .img-wrap {
      width: 60px;
      height: 60px;
      cursor: pointer;
      transition: all 0.3s ease-in-out;
      border-radius: 4px;
      display: flex;
      border: 1px solid transparent;

      img {
        width: 100%;
        max-height: 100%;
        max-width: 100%;
        cursor: pointer;
        border: 1px solid transparent;
        border-radius: 4px;
        object-fit: contain;
      }
    }

    .active {
      border: 1px solid v-bind(primaryColor);
      border-radius: 2px;
    }
  }

  .price {
    .ladder {
      width: calc(100% - 100px);
      overflow-x: auto;
      overflow-y: hidden;
    }

    .column {
      width: 100px;
      min-width: 80px;
      line-height: 30px;
    }

    p:first-child {
      // border-bottom: 1px solid v-bind(primaryColor);
      position: relative !important;
      &::after {
        content: "";
        width: 100%;
        height: 1px;
        background: v-bind(primaryColor);
        opacity: 0.3;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }

    .simple {
      line-height: 30px;
      border: 1px solid v-bind(primaryColor);
      border-radius: 4px;
      overflow: hidden;
    }

    .ladderActive {
      background: #e6f6fe;
    }
  }

  .product-size {
    background: #f8fdff;
    border-radius: 2px;

    li {
      width: 80px;
      text-align: center;
      font-size: 14px;
      display: inline-block;

      input {
        width: 100%;
        border: 1px solid v-bind(primaryColor);
        height: 28px;
        border-radius: 4px;
        color: v-bind(primaryColor);
        text-align: center;
        outline: none;
      }

      input::placeholder {
        color: #b6b6b6;
      }
    }
  }

  .no-size {
    border: 1px solid #81d4fa;
    border-radius: 4px;

    input {
      height: 100%;
      width: 100px;
      outline: none;
    }

    span {
      background: #7bd1f7;
      color: white;
    }
  }

  .imprint-location {
    .label {
      color: #666;
      line-height: 40px;
    }
  }

  .pay {
    .left {
      background: #f8fdff;
      height: 100%;
      position: relative;

      > div {
        span {
          color: v-bind(primaryColor);
        }
      }
    }
  }

  .price-list {
    background: #fafafa;
    width: 100%;

    .total {
      font-size: 16px;

      span,
      em {
        color: #000;
      }
    }

    li {
      display: flex;
      line-height: 26px;
      font-size: 14px;

      span {
        width: 60%;
        color: #666;
      }

      em {
        width: 40%;
        text-align: right;
        font-style: normal;
        color: #666;
      }
    }
  }

  .pay-phone {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: white;
    min-height: 60px;
    border-top: 1px solid #ddd;
    z-index: 1000;

    .price {
      color: red;
    }

    span {
      color: #2196f3;
    }
  }

  .drawer {
    position: fixed;
    bottom: 60px;
    left: 0;
    background: white;
    z-index: 1000;

    .title {
      background: #fafafa;
      line-height: 32px;
    }

    .price-list {
      background: white;
    }
  }

  .mask {
    width: 100%;
    height: 100%;
    background: #000;
    opacity: 0.7;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
  }

  .v-select {
    line-height: 34px;
  }

  :deep(.v-chip--variant-tonal) {
    .v-chip__underlay {
      z-index: -1;
    }
  }
}
.imprint-color {
  width: 24px;
  height: 24px;
}
.imprint-color-selected {
  width: 18px;
  height: 18px;
}
:deep(.auto-select) {
  .v-field {
    padding: 4px 0;
  }
  .v-field__input {
    height: auto !important;
    min-height: 32px !important;
    line-height: 32px;
    padding-left: 8px;
  }
}
:deep(.multi-color) {
  .v-field__input {
    margin-top: -2px;
    height: 34px !important;
  }
}
:deep(.v-chip) {
  border: 1px solid rgba(0, 0, 0, 0.2);
  color: rgba(0, 0, 0, 0.9);
}
:deep(.v-chip.fb-650) {
  border: 1px solid v-bind(primaryColor);
}
.download-template-item-tit {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}
.column {
  &.w120 {
    width: 120px !important;
  }
}
.allowed-demo {
  font-size: 14px;
  line-height: 22px;
  color: rgb(217, 0, 27);
}
@media (min-width: 1280px) and (max-width: 1600px) {
  .download-flyer {
    position: absolute;
    left: 0;
    top: 48px;
  }
}
</style>
